$(document).ready(function(){

  $('.header_desktop_menu .header__links-list li[data-submenu-parent]').hover(function(){

      $(this).find('.sub_menu, .meganav').addClass('active');
    
  },function() {  $(this).find('.sub_menu, .meganav').removeClass('active'); });
  
  $('.header_desktop_menu .navigation__submenu-list li.sub_menu_li').hover(function(){

      $(this).find('.sub_sub_menu').addClass('active');
    
  },function() {  $(this).find('.sub_sub_menu').removeClass('active'); });

  var anno_height = $('.announcement-bar').height();
  var header_height = $('.shopify-section-group-header-group').height();
  var total_height = anno_height + header_height;
  
  document.documentElement.style.setProperty("--height-mobile-header", total_height + "px");
  
})